module.exports = __webpack_public_path__ + "img/win_12.831b0c21.png";